import React from 'react'

function Error() {
  return (
    <div style={{color:'white', fontSize:'50px', textAlign:'center'}}>404 page go back to the home page !</div>
  )
}

export default Error;